import React from "react";

const JarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.0816 7.11931V11.4197C32.0306 16.8519 23.0816 27.81 23.0816 27.81H7.52826C7.52826 27.81 -0.786752 16.2522 8.11282 11.6726V7.11713"
      stroke="#F2AF4A"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M21.9017 7.11931L21.8565 11.4197C30.8055 16.8519 22.54 26.8265 22.54 26.8265L7.52826 27.81C7.52826 27.81 -0.786747 16.2522 8.11282 11.6726V7.11713"
      stroke="#F2AF4A"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M4.86377 22.0093C4.86377 22.0093 10.2366 23.2305 11.2252 17.3338C12.0183 12.6039 16.1167 10.7742 19.3919 15.6547C20.8963 17.9139 23.1164 19.2769 25.8243 14.9394"
      stroke="#F2AF4A"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M5.07129 23.1977C5.07129 23.1977 10.27 24.0308 11.2243 18.1276C12.2387 11.8362 16.8464 10.9312 19.6833 16.4353C20.9319 18.8581 23.4915 20.4936 26.1994 16.1562"
      stroke="#F2AF4A"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M23.8873 8.08762L7.11119 7.65147C6.8262 7.65147 6.55288 7.5366 6.35136 7.33211C6.14984 7.12763 6.03662 6.8503 6.03662 6.56112V4.09036C6.03662 3.80118 6.14984 3.52384 6.35136 3.31936C6.55288 3.11488 6.8262 3 7.11119 3H23.8873C24.1723 3 24.4457 3.11488 24.6472 3.31936C24.8487 3.52384 24.9619 3.80118 24.9619 4.09036V6.99726C24.9619 7.28644 24.8487 7.56377 24.6472 7.76826C24.4457 7.97274 24.1723 8.08762 23.8873 8.08762Z"
      stroke="#F2AF4A"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M23.0277 7.21533L7.11119 7.65147C6.8262 7.65147 6.55288 7.53659 6.35136 7.33211C6.14984 7.12763 6.03662 6.85029 6.03662 6.56111V4.09036C6.03662 3.80118 6.14984 3.52384 6.35136 3.31936C6.55288 3.11488 6.8262 3 7.11119 3H23.0277C23.3127 3 23.586 3.11488 23.7875 3.31936C23.9891 3.52384 24.1023 3.80118 24.1023 4.09036V6.12497C24.1023 6.41415 23.9891 6.69148 23.7875 6.89597C23.586 7.10045 23.3127 7.21533 23.0277 7.21533Z"
      stroke="#F2AF4A"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

export default JarIcon;
